export enum FishFeedBuoyancy {
  SINKING = 'sinking',
  SLOW_SINKING = 'slowSinking',
  FAST_SINKING = 'fastSinking',
  FLOATING = 'floating',
  OTHER = 'other',
}
